import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef, useEffect, useRef, } from "react";
/**
 * Operator checkbox — a native `<input type="checkbox">` in the design-system
 * tokens (`accent-primary`, `border-line`), matching the raw `h-4 w-4 rounded
 * border-line` checkboxes already used across the consoles, plus `indeterminate`
 * support for "select all" tri-state (set imperatively since there is no
 * indeterminate HTML attribute).
 */
export const Checkbox = forwardRef(({ checked, indeterminate = false, onChange, disabled, className = "", ...props }, ref) => {
    const innerRef = useRef(null);
    useEffect(() => {
        if (innerRef.current)
            innerRef.current.indeterminate = indeterminate;
    }, [indeterminate]);
    return (_jsx("input", { ref: (node) => {
            innerRef.current = node;
            if (typeof ref === "function")
                ref(node);
            else if (ref)
                ref.current = node;
        }, type: "checkbox", checked: checked, disabled: disabled, onChange: (e) => onChange?.(e.target.checked, e), className: `h-4 w-4 cursor-pointer rounded border-line accent-primary focus:outline-none focus:ring-2 focus:ring-primary/30 disabled:cursor-not-allowed disabled:opacity-50 ${className}`, ...props }));
});
Checkbox.displayName = "Checkbox";
//# sourceMappingURL=Checkbox.js.map